import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    headerWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    rightWrapper: {
        minWidth: '200px',
    },
}));
